/* 布局 */
//前台
import Layout from "@views/layout";

const gravelatticerelativesRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "gravelatticerelatives/list",
        name: "GRAVELATTICERELATIVES",
        meta: {
            title: "墓区格位亲属管理",
            keepAlive:true
        },
        component: () => import("@views/business/gravelatticerelatives/index.vue"),
    },
        ],
};

export default gravelatticerelativesRouter;
